import { render, staticRenderFns } from "./AffiliateSearch.vue?vue&type=template&id=64c8d5b6&scoped=true"
import script from "./AffiliateSearch.vue?vue&type=script&lang=js"
export * from "./AffiliateSearch.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=64c8d5b6&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c8d5b6",
  null
  
)

export default component.exports